import React from 'react';
import {Box, Typography, Card, IconButton} from '@mui/material';
import './ArrWidgetWrapper.scss';
import ArrIconButton from '../arr-icon-button/ArrIconButton';
import {ReactComponent as IconSettings} from '../../../../src/assets/images/icon-settings.svg';
import {ReactComponent as IconReplace} from '../../../../src/assets/images/icon-replace.svg';
import {t} from 'i18next';
import ArrLoadingSpinner from '../arr-loading-spinner/ArrLoadingSpinner';
import ArrTooltip from '../arr-tooltip/ArrTooltip';
import ArrTooltipWrapper from '../arr-tooltip-wrapper/ArrTooltipWrapper';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

type ArrWidgetWrapperProps = {
  title: string;
  showInfo?: boolean;
  showSettings?: boolean;
  showReplace?: boolean;
  onSettingsClick?: () => void;
  onReplaceClick?: () => void;
  children?: React.ReactNode;
  loading?: boolean;
  error?: boolean;
  tooltipContent?: string;
};

const ArrWidgetWrapper: React.FC<ArrWidgetWrapperProps> = ({
  title,
  showInfo = false,
  showSettings = false,
  showReplace = false,
  onSettingsClick,
  onReplaceClick,
  children,
  loading,
  error,
  tooltipContent = '',
}) => {
  const getContent = () => {
    if (loading) {
      return <ArrLoadingSpinner />;
    } else if (error) {
      return (
        <Box className="widget-no-data">
          <Typography
            className="typo-text subhead4_size"
            data-testid={`arr-widget-wrapper-no-data-${title}`}
          >
            {t('common.arrWidgetWrapper.noData')}
          </Typography>
        </Box>
      );
    } else {
      return <Box className="widget-body">{children}</Box>;
    }
  };
  return (
    <Card className="arr-widget-wrapper-root">
      <Box className="widget-header">
        <Typography
          className="typo-text subhead4_size"
          data-testid={`arr-widget-wrapper-title-${title}`}
        >
          {title}
        </Typography>
        <Box className="widget-icons">
          {showInfo && (
            <ArrTooltipWrapper
              title={title}
              trigger={
                <IconButton
                  aria-label="Info"
                  className="info-icon-button"
                  data-testid={`widget-switcher-${title}`}
                >
                  <InfoOutlinedIcon className="info-icon" fontSize="medium" />
                </IconButton>
              }
            >
              {tooltipContent}
            </ArrTooltipWrapper>
          )}

          {showSettings && (
            <ArrTooltip content={'Customize Widget'}>
              <ArrIconButton
                size="small"
                onClick={() => onSettingsClick?.()}
                ariaLabel={t('common.arrWidgetWrapper.settings')}
                icon={<IconSettings fontSize="medium" />}
                shape="none"
                testId={`widget-settings-${title}`}
              />
            </ArrTooltip>
          )}
          {showReplace && (
            <ArrTooltip content={'Swap Widget'}>
              <ArrIconButton
                size="small"
                onClick={() => onReplaceClick?.()}
                icon={<IconReplace fontSize="medium" />}
                ariaLabel={t('common.arrWidgetWrapper.replace')}
                shape="none"
                testId={`widget-switcher-${title}`}
              />
            </ArrTooltip>
          )}
        </Box>
      </Box>
      {/* Body */}
      {getContent()}
    </Card>
  );
};

export default ArrWidgetWrapper;
